import { getBackendUrl } from "api/common";
import axios from "axios";

interface AppData {
  authUrl: string;
  clientId: string;
  userPoolId: string;
  puzzelClientId: string;
  puzzelIdpScheme?: string;
  puzzelCiqType: string;
  puzzelPhoneNumberPrefix: string;
  puzzelFunctionalNumberPrefix: string;
  puzzelCountryCode: string;
  puzzelMaxAttempts: number;
  puzzelMaxOneRequestForPreferredAgent: boolean;
  puzzelPreferredAgentWaitTimeSeconds: number;
  puzzelQueueKey: string;
  puzzelReservedAgentWaitTimeSeconds: number;
  puzzelSecondsBetweenAttempts: number;
}

export const getAppData = async (): Promise<AppData> => {
  const response = await axios.get<AppData>(`${getBackendUrl()}/app-data`);
  return response.data;
};
